import * as m from '@staiter/i18n';
import { Link } from '@tanstack/react-router';
import type { ProjectApproversResponse } from '~/lib/api/projects';

/**
 * F8 (project-plan-change §5) — почему подписать некому, словами.
 *
 * До пака диалог с подписью просто гасил кнопку: человек видел неактивный
 * контрол и ни слова о причине. Поймано на проде 05.08 — тестовый проект в
 * «Company 00000000» не удалось закрыть штатно ВООБЩЕ, ни архивацией, ни отменой.
 *
 * Инвариант пака: **действие, объявленное возможным, обязано иметь исполнителя.**
 * Гейт, у которого некому подписать, — не гейт, а тупик. Если исполнителя всё же
 * нет, экран обязан назвать: каких ролей не хватает и кто их выдаёт.
 *
 * ОДИН компонент на все диалоги с подписью — отмену, архивацию, возврат из
 * архива, разотмену и перенос срока. Пять копий одного объяснения разошлись бы
 * на первой правке текста, и часть экранов осталась бы с прежней формулировкой.
 *
 * Перечень ролей приходит с сервера (`no_candidates.required_roles`, B10) и
 * включает роли ВСЕХ ступеней добора: сказать «не хватает reviewer/admin»,
 * умолчав, что не нашлось и запасного `company_admin`, — значит отправить
 * человека искать не то.
 */
export function ApproverEmptyNote(props: {
  /** Ответ пикера кандидатов; `no_candidates` приходит только когда список пуст. */
  data: ProjectApproversResponse | undefined;
  className?: string | undefined;
}): JSX.Element | null {
  const nc = props.data?.no_candidates;
  if (!nc) return null;
  return (
    <span className={props.className} role="status">
      {m.approver_none_available({ roles: nc.required_roles.join(', ') })}{' '}
      {/* Гейт фазы C (UX-4): осмысленное пустое состояние требует ДЕЙСТВИЯ, а не
          только объяснения. Текст называл роли и того, кто их выдаёт, но идти за
          этим было некуда. */}
      <Link to="/admin/users" className="link-inline">
        {m.approver_none_available_cta()}
      </Link>
    </span>
  );
}

/** Кандидатов нет ни на одной ступени добора — кнопку подтверждения держать нечем. */
export function hasNoApproverCandidates(data: ProjectApproversResponse | undefined): boolean {
  return !!data?.no_candidates;
}
